import styled from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';
import { MeasurementUnit } from 'common/api-types/common';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const Text = styled.span`
  white-space: nowrap;
  color: ${color.textSubdued};
`;

type Props = {
  reservedQuantity: number;
  measurementUnit: MeasurementUnit;
};

export const ReservedQuantity = ({ reservedQuantity, measurementUnit }: Props) => {
  const f = useFormatMessage();

  return (
    <Text>
      (
      {f('warehouse.common.reserved_quantity_with_measurement_unit', {
        reservedQuantity,
        measurementUnit: f(`warehouse.measurement_unit:${measurementUnit}`, {
          count: reservedQuantity,
        }),
      })}
      )
    </Text>
  );
};
